import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { SigninComponent } from './auth/signin/signin.component';

const routes: Routes = [

  {
    path: '',
    title: 'Connexon',
    component: SigninComponent,
  },{
    path: 'home/:referenceSeance',
    title: 'Home',
    component: HomeComponent,
    //canActivate: [AuthGuard]
  },
  // {
  //   path: '',
  //   loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  // },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PublicRoutingModule {}
